import { Infrastructure } from "../Infrastructure/Infrastructure";
import { Parameter } from "../Infrastructure/Parameter";
import { ParameterSource } from "./ParameterSource";
import ParameterSourceRepository from "./ParameterSourceRepository";

export default class ParameterSourceService {
  private readonly parameterSourceRepository: ParameterSourceRepository =
    new ParameterSourceRepository();

  async saveSourcesByInfrastructure(
    infrastructure: Infrastructure,
    parameter: Parameter,
    sources: ParameterSource[]
  ): Promise<boolean> {
    const sourcesParsed = sources
      .map((source) => {
        const [serialDeviceId, serialSensorId] = (source.sourceSerialNumber ?? "").split(":");
        const deviceLat = source.deviceLatitude ?? infrastructure.latitude;
        const deviceLng = source.deviceLongitude ?? infrastructure.longitude;
        const sensorLat = source.sensorLatitude ?? infrastructure.latitude;
        const sensorLng = source.sensorLongitude ?? infrastructure.longitude;
        return {
          ...(source.id >= 0 ? { id: source.id } : {}),
          name: source.name,
          enabled: source.isEnabled,
          sourceSerialNumber: source.sourceSerialNumber,
          virtual: source.isVirtual,
          deviceId: source.deviceId ?? serialDeviceId ?? null,
          sensorId: source.sensorId ?? serialSensorId ?? null,
          deviceCoordinates: `${deviceLng},${deviceLat}`,
          sensorCoordinates: `${sensorLng},${sensorLat}`,
          statement: source.statement,
          variablesDTOS: source.variablesDTOS,
          virtualCurrentTs: source.virtualCurrentTs,
          virtualType: source.virtualType,
          inpId: source.inpId,
          objectTypeId: source.objectTypeId,
          objectModelId: source.objectModelId,
          unitId: source.unitId,
          unitName: source.unitName,
          unitScale: source.unitScale,
          unitOffset: source.unitOffset,
          unitIsCustom: source.unitIsCustom,
          historicalMetService: source.historicalMetService,
          forecastMetService: source.forecastMetService,
        };
      })
      .filter((source) => {
        return (
          source.name !== "" &&
          source.sourceSerialNumber !== "" &&
          source.sourceSerialNumber?.split(":").length >= 2
        );
      });
    return this.parameterSourceRepository.saveSources(
      infrastructure.id,
      parameter.id,
      sourcesParsed
    );
  }

  async deleteSource(parameter: ParameterSource) {
    return this.parameterSourceRepository.deleteParameter(parameter.id);
  }
}
